import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'

const TiresWheels = ({ globalData }) => {
    return (
        <Container>
            <Row>
                <Col md={12} className="mt-2">

                    <div className="content-main-div">
                        <h1 className="content-heading">
                            Enhance Your Ride with Premium Tires & Wheels Services in UAE
                        </h1>
                        <p className="content-paragraph">Open Bonnet is your one-stop shop for all your tire and wheel needs, providing a range of services designed to keep your vehicle in top condition. Here's what we offer:</p>

                        <h4 className="content-sub-heading">Wheel Alignment And Balancing Services
                        </h4>
                        <p className="content-paragraph">Proper wheel alignment and balancing are essential for ensuring a smooth and safe ride. Our experts use state-of-the-art equipment and technology to ensure that your car wheels are aligned and balanced to the manufacturer's specifications.
                        </p>

                        <h4 className="content-sub-heading">Choose Your Right Fit Wheel Service at Open Bonnet:
                        </h4>
                        <p className="content-paragraph">With so many wheel options available, it can be difficult to choose the right fit for your vehicle. Our team of experts can help you select the perfect wheels that not only look great but also provide the best performance and safety for your car.
                        </p>

                        <ul className="content-second-list">
                            <li className="list-li">
                                <span className="list-li-span">Tyre replacement:</span>
                                When it's time to replace your tires, you want to make sure that you're getting high-quality products that are built to last. We offer a wide selection of top-brand tires at competitive prices.
                            </li>
                            <li className="list-li">
                                <span className="list-li-span">Tyre Rotation:</span>
                                To extend the life of your tires and improve their performance, regular tire rotation is necessary. We recommend rotating your tires every 10,000 kms to ensure even wear.
                            </li>
                            <li className="list-li">
                                <span className="list-li-span">Wheel alignment:</span>
                                Wheel alignment is crucial to the overall performance and safety of your vehicle. Our experts use state-of-the-art technology to ensure that your wheels are properly aligned and performing at their best.
                            </li>
                            <li className="list-li">
                                <span className="list-li-span">Wheel Balancing:</span>
                                Proper wheel balancing is essential for a smooth ride and even tire wear. Our team of experts uses advanced equipment to ensure that your wheels are perfectly balanced.
                            </li>
                            <li className="list-li">
                                <span className="list-li-span">About Tyres And Wheel Care:</span>
                                Taking care of your tires and wheels is essential for the safety and performance of your vehicle. Our experts can provide you with tips and advice on how to care for your tires and wheels to ensure that they last as long as possible.
                            </li>
                        </ul>

                        <p className="content-paragraph">In addition to our tire and wheel services, we also offer <a className='paragraph-link' href={`/services/${globalData.locationData?.data?.EmirateAreaSlug ||
                            "dubai"
                            }/battery`}>Battery Replacement</a>. If your vehicle's battery is old or no longer holding a charge, our experts can assist you in finding and installing the right battery for your car.
                        </p>
                        <p className="content-paragraph">At Open Bonnet, we are committed to providing you with the best tire and wheel services available. Whether you need new tires, a wheel alignment, or just advice on how to care for your wheels, our team of experts is here to help. Contact us today to schedule an appointment or to learn more about our services.
                        </p>
                    </div >

                </Col >
            </Row >
        </Container >
    )
}

export default TiresWheels
